/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 48, height = 48 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48" fill="none">
    <path d="M22.1839 3.93733C22.8987 2.38758 25.1013 2.38759 25.8161 3.93733L30.3024 13.6635C30.5937 14.2952 31.1923 14.73 31.883 14.8119L42.5195 16.0731C44.2143 16.274 44.8949 18.3688 43.6419 19.5275L35.7781 26.7998C35.2674 27.272 35.0388 27.9757 35.1744 28.6579L37.2618 39.1636C37.5944 40.8375 35.8125 42.1321 34.3233 41.2985L24.9769 36.0668C24.3699 35.7271 23.6301 35.7271 23.0231 36.0668L13.6767 41.2985C12.1875 42.1321 10.4056 40.8375 10.7382 39.1636L12.8256 28.6579C12.9612 27.9757 12.7326 27.272 12.2219 26.7998L4.35805 19.5275C3.10505 18.3688 3.78569 16.274 5.48048 16.0731L16.117 14.8119C16.8077 14.73 17.4063 14.2952 17.6976 13.6635L22.1839 3.93733Z"
      fill="#E8DFD7" stroke="#D6C7BA" strokeWidth="1.5"/>
  </svg>
);

export default SvgComponent;
